import { Button } from "@bowfast/ui/components/button";
import { Link } from "@tanstack/react-router";
import { CompassIcon } from "lucide-react";

interface StubPageProps {
  /** Page heading */
  title: string;
  /** Supporting copy — nautical, not corporate */
  description: string;
  /** Optional primary CTA label */
  actionLabel?: string;
  /** Optional TanStack Router destination for the CTA */
  actionTo?: string;
}

export function StubPage({ title, description, actionLabel, actionTo }: Readonly<StubPageProps>) {
  return (
    <div className="flex min-h-[55vh] flex-col items-center justify-center gap-5 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-muted">
        <CompassIcon className="size-8 text-muted-foreground/40" />
      </div>
      <div className="max-w-sm">
        <h1 className="font-heading text-xl font-bold">{title}</h1>
        <p className="mt-1.5 text-sm text-muted-foreground">{description}</p>
      </div>
      {actionLabel && actionTo && (
        <Button nativeButton={false} render={<Link to={actionTo} />}>
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
